import { render, staticRenderFns } from "./detailsbomTip.vue?vue&type=template&id=17d74eed&"
import script from "./detailsbomTip.vue?vue&type=script&lang=js&"
export * from "./detailsbomTip.vue?vue&type=script&lang=js&"
import style0 from "./detailsbomTip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports